export enum EnumBalcaoSalao {
    UTILIZA = 1,
    NAO_UTILIZA = 2,
}
